'use client';

import Link from 'next/link';

import type { HeaderClientProps } from '@eliadmin/core/src/components/header/header-client';

import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { HeaderCategories } from '@eliadmin/core/src/components/header/header-categories';

import { ButtonIcon } from '@eliadmin/core/src/components/ui/button-icon';
import { ROUTES } from '@eliadmin/core/src/constants/routes';

export function HeaderBottom({ categories }: HeaderClientProps) {
  const { t } = useTranslations();

  return (
    <div className={cn('custom-section', 'hidden border-b pb-4 pt-2 sm:flex')}>
      <div className={cn('custom-container', 'flex items-center justify-between gap-4')}>
        <div className="flex items-center justify-start gap-4">
          <HeaderCategories categories={categories} />
          {/* <div className="h-[6px] w-[6px] rounded-full bg-border" />
          <Link
            href={'#'}
            className="text-sm font-semibold text-foreground transition-all hover:opacity-90 xl:text-base"
          >
            Identifikovať diel
          </Link> */}
          <div className="h-[6px] w-[6px] rounded-full bg-border" />
          <Link
            href={ROUTES.SALES()}
            className="generic-hover flex items-center justify-start gap-2 text-sm font-semibold text-[#EA2A30] transition-all hover:opacity-90 xl:text-base"
          >
            <ButtonIcon alt={t('text3265')} url="/images/icons/sale.svg" />
            {t('text3265')}
          </Link>
          <div aria-hidden="true" className="h-[6px] w-[6px] rounded-full bg-border" />
          <Link
            href="/predajcovia"
            prefetch={false}
            className="text-sm font-semibold text-foreground transition-all hover:opacity-90 xl:text-base"
          >
            Predajcovia
          </Link>
        </div>
      </div>
    </div>
  );
}
